import React from "react";
import propTypes from "prop-types";
import { createDataAttributes } from "../../utilities";

import classnames from "classnames";

import "./ExternalLink.scss";

const pattern =
  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

const ExternalLink = ({
  to,
  className,
  target,
  rel,
  children,
  dataAttrib,
  ...rest
}) => {
  const url = pattern.test(to) ? to : null;

  const customClasses = classnames("uikit__external-link", className);

  return (
    <a
      {...rest}
      href={url}
      className={customClasses}
      target={target}
      rel={target === "_blank" ? `noopener noreferrer ${rel}` : rel}
      {...createDataAttributes(dataAttrib)}
    >
      {children}
    </a>
  );
};

ExternalLink.propTypes = {
  to: propTypes.string.isRequired,
  children: propTypes.oneOfType([propTypes.node, propTypes.element]).isRequired,
  className: propTypes.string,
  target: propTypes.string,
  rel: propTypes.string,
  dataAttrib: propTypes.arrayOf(Object)
};

ExternalLink.defaultProps = {
  target: "_blank"
};

export default ExternalLink;
